import React from 'react';
import { motion } from 'framer-motion';
const TOMOS = [{
  emoji: '📘',
  title: 'Tomo 1 — El Motor de Planificaciones',
  desc: 'Planificaciones anuales y de unidad con IA en 7 minutos.'
}, {
  emoji: '📗',
  title: 'Tomo 2 — El Generador de Secuencias',
  desc: 'De la unidad didáctica a la clase del lunes en 8 minutos.'
}, {
  emoji: '📙',
  title: 'Tomo 3 — La Fábrica de Evaluaciones',
  desc: 'Instrumentos de evaluación profesionales en 5 minutos.'
}, {
  emoji: '📕',
  title: 'Tomo 4 — El Asistente de Corrección',
  desc: 'Corregí 40 trabajos en el tiempo que antes te llevaba 10.'
}, {
  emoji: '📓',
  title: 'Tomo 5 — El Diseñador de Actividades',
  desc: 'Actividades que enganchan y no te llevan toda la tarde.'
}, {
  emoji: '📒',
  title: 'Tomo 6 — El Maestro Digital',
  desc: 'Herramientas y estrategias de vanguardia para el aula.'
}];
export function ProductSection() {
  return <section className="py-14 bg-zinc-950" data-id="element-251">
      <div className="max-w-3xl mx-auto px-4" data-id="element-252">
        <div className="text-center mb-10" data-id="element-253">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-2xl md:text-4xl font-black uppercase tracking-tight text-white mb-3" data-id="element-254">
            Sistema de Productividad Docente™
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-base md:text-lg text-gray-400 max-w-2xl mx-auto" data-id="element-255">
            La colección completa de 6 manuales en PDF diseñados para que
            domines la IA en el aula argentina y nunca más empieces desde cero.
          </motion.p>
        </div>

        <div className="space-y-3" data-id="element-256">
          {TOMOS.map((tomo, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.1
        }} className="bg-zinc-900 border border-zinc-800 border-l-4 border-l-yellow-500 rounded-r-xl p-4 md:p-5 flex flex-row items-center gap-3 hover:bg-zinc-800/50 transition-colors" data-id="element-257">
              <div className="text-2xl flex-shrink-0" data-id="element-258">{tomo.emoji}</div>
              <div data-id="element-259">
                <h3 className="text-base md:text-lg font-bold text-white mb-0.5" data-id="element-260">
                  {tomo.title}
                </h3>
                <p className="text-sm text-gray-400" data-id="element-261">{tomo.desc}</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}